<script>
import simplebar from "simplebar-vue";

import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import { required } from "vuelidate/lib/validators";
import Vue from 'vue'
import VueChatScroll from 'vue-chat-scroll'

import db from '@/firebase/init.js';  
import firebase from "firebase/app";
import 'firebase/storage';
import moment from 'moment'; 

Vue.use(VueChatScroll)

/**
 * Chat Component
 */
export default {
  page: {
    title: "Chat",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    simplebar,
  },
  data() {
    return {
      title: "Chat",
      items: [
        {
          text: "Chat",
          active: true,
        },
      ],
      submitted: false,
      form: {
        message: "",
      },
      user: {},
      token: '',
      current_user: {
        user_id: null,
        name: "",
        index: 0,
        email:"",
        mobile:"",
        country_code:"",
      },
      users: [],      

      file: '',
      preview_image: '',
      isFile: false,
      file_path: '',
      unread_alert: false,
      unread_title: false,
      timer: null,

    };
  },
  validations: {
    form: {
      message: {
        required,
      },
    },
  },
  mounted() {
    this.clearLocalStorage();

  },
  created() {
    this.getToken();
    this.listenChatUsers();
  },
  beforeDestroy () {
  },
  computed: {
    currentUserMessageCount() {
      const idx = this.current_user.index;
      return (this.users[idx] && this.users[idx].messages)
        ? this.users[idx].messages.length
        : 0;
    },
  },
  watch: {
    currentUserMessageCount() {
      this.$nextTick(() => this.scrollToBottom());
    },
  },
  methods: {
    clearLocalStorage() {
      localStorage.removeItem("consultation_filters");
      localStorage.removeItem("cancel_consultation_filters");
      localStorage.removeItem("patient_filters");
      localStorage.removeItem("doctor_filters");
    },
    getToken() {
      if (localStorage.getItem('medicino_admin')) {
        var medicino_admin =  JSON.parse(localStorage.getItem('medicino_admin'));
        if(medicino_admin.token) {

          this.token = medicino_admin.token;
          this.user = medicino_admin;
          
        } else {
          this.$swal("", "Failed to fetch token, please login again", "error");
          this.$router.push({ name: "login" });
        }
               
      } else {
        this.$swal("", "Session expired, please login again", "error");
        this.$router.push({ name: "login" });
      }
    }, 

    listenChatUsers() {  
        this.unread_alert = false;
        db.collectionGroup('messages').orderBy("timestamp", "desc")
        .onSnapshot((querySnapshot) => {  
          var users = [];
          querySnapshot.docs.forEach((doc) => {   
            var user = doc.data();

            db.collectionGroup(user.user_id.toString())
            .onSnapshot(snapshot => {
                user.messages = [];
                user.admin_unread = false;
                snapshot.docs.forEach((collection) => {
                  user.messages.push(collection.data());
                  if(collection.data().isRead == false && collection.data().idTo == 0) {
                    this.unread_alert = true;
                    user.admin_unread = true;
                  }
                });
                const itemIndex = users.findIndex(item => item.user_id === 
                      user.user_id);

                if (itemIndex !== -1) {
                      users[itemIndex] = user;
                } else {
                      users.push(user);
                }

                if (querySnapshot.docs.length === users.length) {
                  this.setUsers(users);
                }
            });            
       
          });
        });

    },

    setUsers(users) {
      this.users = users;
      console.log(this.users);
      this.current_user.user_id = this.users[0].user_id;
      this.current_user.name = this.users[0].name;
      this.current_user.index = 0;
      this.fetchPatient(this.current_user.user_id);  
      this.scrollToBottom();
    },

    setCurrentUser(data) {
      this.current_user.user_id = data.user_id;
      this.current_user.name = data.name;
      this.unread_title = false; 
      this.fetchPatient(this.current_user.user_id);  

      db.collectionGroup(this.current_user.user_id.toString())
      .get().then((id_collection) => {
        id_collection.docs.forEach((collection) => {
          if(collection.data().idTo == 0) {
            collection.ref.update({
              isRead: true,
            });
          }
        });
      });    

      this.scrollToBottom();
    },

    fetchPatient(user_id) {
            let url = "api/admin/patient/profile1?id=" + user_id;         
            this.getToken();
            this.loading = true;
            this.$axios
            .get(url, { headers: { Authorization: "Bearer " + this.token } })
            .then((res) => {
               var responseData = res.data.data;
               console.log(responseData);
                if(responseData.patient){
                    this.current_user.country_code = responseData.patient.country_code;  
                    this.current_user.mobile = responseData.patient.mobile;  
                    this.current_user.email = responseData.patient.email;  
                }else{
                    this.current_user.country_code = "";  
                    this.current_user.mobile = "";  
                    this.current_user.email = "";  
                }
            })
            
         },
    scrollToBottom() {
      this.$nextTick(() => {
        const wrapper = this.$refs.current && this.$refs.current.$el && this.$refs.current.$el.querySelector(".simplebar-content-wrapper");
        if (wrapper) {
          wrapper.scrollTop = wrapper.scrollHeight;
        }
      });
    },


    /**
     * Char form Submit
     */
    // eslint-disable-next-line no-unused-vars
    async formSubmit(e) {
      this.submitted = true;
      var message = '';
      var timestamp = moment().valueOf();
      var utc = firebase.firestore.FieldValue.serverTimestamp();
      var user_id = this.current_user.user_id;
      //var name = this.current_user.name;
      var type = 0;

      let promise = new Promise((resolve) => {

        if(this.isFile) {
          var storageRef = firebase.storage().ref();
          var metadata;
          if(this.preview_image) {
            type = 1;
         
            // Create the file metadata
            metadata = {
              contentType: 'image/jpeg'
            };
          } else {
            type = 2;
         
            // Create the file metadata
            metadata = {
              contentType: 'application/pdf'
            };
          }

          var filename = timestamp.toString();
          //alert(filename);
          // Upload file and metadata to the object 'images/mountains.jpg'
          var uploadTask = storageRef.child(filename).put(this.file, metadata);

          // Listen for state changes, errors, and completion of the upload.
          uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
            (snapshot) => {
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log('Upload is ' + progress + '% done');
              switch (snapshot.state) {
                case firebase.storage.TaskState.PAUSED: // or 'paused'
                  console.log('Upload is paused');
                  break;
                case firebase.storage.TaskState.RUNNING: // or 'running'
                  console.log('Upload is running');
                  break;
              }
            }, 
            (error) => {
              // A full list of error codes is available at
              // https://firebase.google.com/docs/storage/web/handle-errors
              switch (error.code) {
                case 'storage/unauthorized':
                  // User doesn't have permission to access the object
                  break;
                case 'storage/canceled':
                  // User canceled the upload
                  break;

                // ...

                case 'storage/unknown':
                  // Unknown error occurred, inspect error.serverResponse
                  break;
              }
            }, 
            () => {
              // Upload completed successfully, now we can get the download URL
              uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
                console.log('File available at', downloadURL);
                this.file_path = downloadURL;
                message = this.file_path;
                resolve(true);
              });
            }
          );

          
        } else {

          // stop here if form is invalid
          this.$v.$touch();

          if (this.$v.$invalid) {
            return;
          } else {      
            type = 0;
            message = this.form.message;
            resolve(true);
          }
        }
        
      });

      let is_done = await promise;
      if(is_done) {  
        //alert(message);
        if(message != '') {
          
          //console.log(message);
          //console.log(timestamp);
          //console.log(utc);
          

          var docRef = db.collection("messages").doc(user_id.toString()).collection(user_id.toString()).doc(timestamp.toString());
          docRef.set({
            content: message,
            idFrom: 0,
            idTo: user_id,
            isRead: false,
            timestamp: utc,
            type: type,
            chat_id: timestamp,
          });

          db.collection("messages").doc(user_id.toString()).update({
            last_message: message,
            last_message_type: type,
            last_message_is_read: false,
            timestamp: utc,
          });
       
          this.clearForm();
          this.scrollToBottom();
        }
      }
      
    },


    deleteChat(data) {
      
      db.collection("messages").doc(`${this.current_user.user_id}`).collection(`${this.current_user.user_id}`).doc(`${data.chat_id}`).delete().then(() => {
          //this.getChats(this.current_user.user_id, this.current_user.name);
      }).catch(() => {
          this.$swal("", "Something went wrong", "error");
      });
    },

    selectImage(){
      let fileInputElement = this.$refs.file;
      fileInputElement.click();
    },

    selectFile(){
      let fileInputElement = this.$refs.pdf;
      fileInputElement.click();
    },

    setImage(e) {
      this.file = e.target.files[0];
      this.preview_image = URL.createObjectURL(e.target.files[0]);
      this.isFile = true;
    },

    setFile(e) {
      this.file = e.target.files[0];
      this.preview_image = '';
      this.isFile = true;
    },

    clearForm() {
      this.file = '';
      this.preview_image = '';
      this.isFile = false;
      this.form.message = '';
      this.submitted = false;
      this.form = {};
    },

    checkifUnread(index) {
      if(this.users[this.current_user.index].messages[index].isRead == false && this.unread_title == false) {
        this.unread_title = true;
        return true;
      } else {
        return false;
      }
    }

  },
  
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="d-lg-flex">
      <div class="chat-leftsidebar me-lg-4">
        <div class>
          <div class="py-4 border-bottom">
            <div class="d-flex">
              <div class="align-self-center me-3">
                <img v-if="user && user.image" :src="$image_url + user.image" class="avatar-xs rounded-circle" alt="" />
                <img v-else src="@/assets/images/no-user.jpg" class="avatar-xs rounded-circle" alt="" />
              </div>
              <div class="flex-grow-1">
                <h5 class="font-size-15 mt-3 mb-1">{{user.name}}</h5>
              </div>
              <b-dropdown v-if="unread_alert"
                menu-class="dropdown-menu-end"
                class="chat-noti-dropdown active"
                right disabled
                variant="white"
              >
              <i class="bx bx-bell bx-tada"></i>
                <template v-slot:button-content>
                  <i class="bx bx-bell bx-tada"></i>
                </template>
              </b-dropdown>

              <b-dropdown v-else
                menu-class="dropdown-menu-end"
                class="chat-noti-dropdown"
                right disabled
                variant="white"
              >
              <i class="bx bx-bell"></i>
                <template v-slot:button-content>
                  <i class="bx bx-bell"></i>
                </template>
              </b-dropdown>
              
            </div>
          </div>
        </div>

        <!-- <div class="search-box chat-search-box py-4">
          <div class="position-relative">
            <input type="text" class="form-control" placeholder="Search..." />
            <i class="bx bx-search-alt search-icon"></i>
          </div>
        </div> -->

        <div class="chat-leftsidebar-nav">
              <b-card-text>
                <div>
                  <h5 class="font-size-14 mb-3">Recent</h5>
                  <simplebar style="max-height: 410px" id="chat-list">
                    <ul class="list-unstyled chat-list" v-if="users.length">
                      <!-- <li
                        class
                        v-for="data of users"
                        :key="data.user_id"
                        @click="getChats(data.user_id, data.name)"
                        :class="{ active: current_user.user_id == data.user_id }"
                      > -->
                      <li
                        class
                        v-for="(data, index) of users"
                        :key="data.user_id"
                        @click=" current_user.index = index, setCurrentUser(data)"
                        :class="{ active: current_user.user_id == data.user_id }"
                      >
                        <a href="javascript: void(0);">
                          <div class="d-flex">
                            <div class="align-self-center me-3">
                              <i v-if="!data.admin_unread"
                                :class="`mdi mdi-circle text-light font-size-10`"
                              ></i>
                              <i v-else
                                :class="`mdi mdi-circle text-danger font-size-10`"
                              ></i>
                            </div>
                            <div
                              class="align-self-center me-3"
                              v-if="data.profile_image"
                            >
                              <img
                                :src="`${data.profile_image}`"
                                class="rounded-circle avatar-xs"
                                alt
                              />
                            </div>
                            <div
                              class="avatar-xs align-self-center me-3"
                              v-if="!data.profile_image"
                            >
                              <span
                                class="avatar-title rounded-circle bg-soft bg-primary text-primary"
                                >{{ data.name.charAt(0) }}</span
                              >
                            </div>
                            <div class="flex-grow-1 overflow-hidden">
                              <h5 class="text-truncate font-size-14 mb-1">
                                {{ data.name }}
                              </h5>
                              <p class="text-truncate mb-0">
                                <span v-if="data.last_message_type==0">{{ data.last_message | excerpt(25) }}</span>
                                <span v-if="data.last_message_type==1">image</span>
                                <span v-if="data.last_message_type==2">pdf</span>
                              </p>
                            </div>
                            <div v-if="data.timestamp" class="font-size-11">{{ data.timestamp.toDate() | chatTime  }}</div>
                          </div>
                        </a>
                      </li>
                    </ul>
                  </simplebar>
                </div>
              </b-card-text>
        </div>
      </div>
      <div class="w-100 user-chat" v-if="current_user.user_id">
        <div class="card">
          <div class="p-4 border-bottom">
            <div class="row">
              <div class="col-md-4 col-9">
                <h5 class="font-size-15 mb-1">{{ current_user.name }}</h5>{{ current_user.country_code }}{{ current_user.mobile }}<br>{{ current_user.email }}
                <!-- <p class="text-muted mb-0">
                  <i class="mdi mdi-circle text-success align-middle me-1"></i>
                  Active now
                </p> -->
              </div>
              <div class="col-md-8 col-3">
                
              </div>
            </div>
          </div>

          <div class="chat-users">
            <div class="chat-conversation p-3">
              <simplebar
                style="max-height: 410px"
                id="containerElement"
                ref="current"
              >                
                <ul class="list-unstyled" ref="chat_container"  v-chat-scroll="{always: false, smooth: true}">
                  <!-- <li>
                    
                  </li> -->
                  <li
                    v-for="(data, index) of users[current_user.index].messages"
                    :key="index"
                    :class="{ right: `${data.idFrom}` == 0 }"
                  >
                    <div class="chat-day-title" :class="checkifUnread(index) ? '' : 'd-none' ">
                      <span class="title">Unread Messages</span>
                    </div>
                    <div class="conversation-list" v-if="data">
                      <a v-if="data.idFrom==0" @click="deleteChat(data)" href="javascript: void(0);" class="float-start text-dark me-1"><i class='bx bx-trash'></i></a>
                      <div class="ctext-wrap">
                        <div class="conversation-name">{{ data.name }}</div>
                        <p v-if="data.type==0">{{ data.content }}</p>
                        <a :href="data.content" target="_blank"><img v-if="data.type==1" :src="data.content" alt="image" class="w-100 mb-1" style="max-width:250px;"></a>
                        <a :href="data.content" target="_blank"><img v-if="data.type==2" src="@/assets/images/pdf.png" alt="pdf" class="w-100 mb-1" style="max-width:75px;"></a>
                        <p class="chat-time mb-0" v-if="data.timestamp">
                          <i class="bx bx-time-five align-middle me-1"></i>
                          {{ data.timestamp.toDate() | chatTime  }}
                        </p>
                      </div>
                    </div>
                  </li>
                </ul>
              </simplebar>
            </div>
            <div class="p-3 chat-input-section">
              <form @submit.prevent="formSubmit" class="row">
                <div class="col">
                  <div class="position-relative" v-if="!isFile">
                    <input
                      type="text"
                      v-model="form.message"
                      class="form-control chat-input rounded"
                      placeholder="Enter Message..."
                      :class="{
                        'is-invalid': submitted && $v.form.message.$error,
                      }"
                    />
                    <div
                      v-if="submitted && $v.form.message.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.message.required"
                        >This value is required.</span
                      >
                    </div>
                    <div class="chat-input-links">
                      <ul class="list-inline mb-0">
                        
                        <li class="list-inline-item">
                          <input id="fileUpload" type="file" hidden  ref="file" @change="setImage($event)" accept=".png,.jpg,.jpeg">                          
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Images" @click="selectImage()"
                          >
                            <i class="mdi mdi-file-image-outline"></i>
                          </a>
                        </li>
                        <li class="list-inline-item">
                          <!-- <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="Add Files"
                          >
                            <i class="mdi mdi-file-document-outline"></i>
                          </a> -->
                          <input type="file" hidden  ref="pdf" @change="setFile($event)" accept=".pdf">                          
                          <a
                            href="javascript: void(0);"
                            v-b-tooltip.hover
                            placement="top"
                            title="PDF" @click="selectFile()"
                          >
                            <i class="mdi mdi-file-pdf-outline"></i>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="position-relative" v-if="isFile">
                    <div class="del-wrapper float-start">
                      <img v-if="preview_image" class="avatar-md" :src="preview_image">
                      <img v-else class="avatar-md" src="@/assets/images/pdf.png">
                      <a href="javascript: void(0);" @click="clearForm()" class="del-icon"><i class="mdi mdi-close-circle text-danger font-size-20"></i></a>
                    </div>

                  </div>
                </div>
                <div class="col-auto">
                  <button
                    type="submit"
                    class="btn btn-primary btn-rounded chat-send w-md"
                  >
                    <span class="d-none d-sm-inline-block me-2">Send</span>
                    <i class="mdi mdi-send"></i>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- end row -->
  </Layout>
</template>
